import React from "react";
import Hero from "./components/Hero";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

export default function App() {
  return (
    <div className="App">
      <Hero />
    </div>
  );
};